import { d as _extends, b as _objectSpread } from './chunk-eb25cfa0.js';
import { createElement } from 'react';
import { object } from 'prop-types';
import { Container } from 'constate';
var initialState = {
  visible: false
};
var actions = {
  show: function show() {
    return function () {
      return {
        visible: true
      };
    };
  },
  hide: function hide() {
    return function () {
      return {
        visible: false
      };
    };
  },
  toggle: function toggle() {
    return function (state) {
      return {
        visible: !state.visible
      };
    };
  }
};

var HiddenContainer = function HiddenContainer(props) {
  return createElement(Container, _extends({}, props, {
    initialState: _objectSpread({}, initialState, props.initialState),
    actions: actions
  }));
}; // @ts-ignore


HiddenContainer.propTypes = {
  initialState: object
};
var HiddenContainer$1 = Object.assign(HiddenContainer, {
  initialState: initialState,
  actions: actions
});
export { HiddenContainer$1 as a };